import { CustomCell, CustomRenderer, GridCellKind } from '@glideapps/glide-data-grid'

import { ThemeMode } from '@makyoapp/makyo-ui'

import { CustomGridCellKind } from '@/components/GridV2/helpers/CustomGridCellKind'

interface SkeletonCellProps {
  readonly kind: 'skeleton'
  readonly exstra: { theme: ThemeMode }
}

export type SkeletonCell = CustomCell<SkeletonCellProps>

const SkeletonRenderer: CustomRenderer<SkeletonCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is SkeletonCell =>
    (cell.data as SkeletonCellProps).kind === CustomGridCellKind.Skeleton,
  draw: (args) => {
    const { ctx, theme, rect, requestAnimationFrame, cell } = args
    const themeMode = cell.data.exstra?.theme || 'light'

    // Select skeleton color based on theme mode
    let skeletonColor = theme.bgBubble
    if (themeMode === 'dark') {
      skeletonColor = '#2d3b51'
    }

    const duration = 1000
    const time = (performance.now() % duration) / duration
    const opacity = 0.75 + 0.25 * Math.sin(2 * Math.PI * time)

    const hexToRGBA = (hex: string, opacity: number) => {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${opacity})`
    }

    ctx.fillStyle = hexToRGBA(skeletonColor, opacity)
    ctx.beginPath()
    ctx.roundRect(rect.x + 4, rect.y + 4, rect.width - 8, rect.height - 8, 4)
    ctx.fill()

    requestAnimationFrame()

    return true
  },
  provideEditor: () => undefined,
}

export default SkeletonRenderer
